export interface PreventiveMaintenance {
    cdftAdditionalDueDate: string; 
    cdftDueDate: string;
    cdftLatestDate: string;
    cdftStatus: string;
    daysOverdue: number;
    daysSinceLastCdft: number;
    fieldLongName: string;
    id: string;
    inputDate: string;
    planDate: string;
    remark: string;
    stringIndicatorLongName: string;
    stringShortName: string;
    wellLongName: string;
    wellProductionStatus: string;
    wellStringId: string;
    stringLongName: string;
}

export interface PMRecord {
    records: PreventiveMaintenance[]
}